const pages = {
  OwnerUnits: "OwnerUnits",
  UnitOwners: "UnitOwners",
  EvaluationInterests: "EvaluationInterests",
  OwnerIDIPersons: "OwnerIDIPersons",
  TaxRollLeads: "TaxRollLeads",
  LeaseLeads: "LeaseLeads",
  OwnerOwnerNameAddresses: "OwnerOwnerNameAddresses",
  OwnerNameAddressValidationCluster: "OwnerNameAddressValidationCluster",
  Activities: "Activities",
  Conversations: "Conversations",
  DivisionOrders: "DivisionOrders",
  ManagementWellAssets: "ManagementWellAssets",
  AssetManagementWells: "AssetManagementWells",
  UnitEvaluationWells: "UnitEvaluationWells",
};

export { pages };
